import { Container,Row,Col } from "react-bootstrap";
import React from "react";

import Label from "lib/Label";
import ToolTipV1 from "lib/TooltipV1";
import ErrorMessage from "lib/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import { clearSelectedDataKey, setSelectedData } from "redux/formDisplay";
import "./index.scss";
import { gridValues } from "helper/destructureObject";
import { useEffect } from "react";
import { setRecursiveFormData } from "redux/recursiveReducer";

const RadioInput = (props) => {
  const {
    name,
    label,
    onChange,
    options,
    web_grid_col,
    mobile_grid_col,
    tooltip,
    tooltipText,
    value,
    class_name,
    error,
    size,
    validators,
    is_disabled,
    auto_checked,
    workflowUser,
    isEditable // is used when RM requests to resend certain fields to the applicant
    // when editable is true only that field will be editable and rest will be disabled
 
  } = props;
  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";
  const dispatch = useDispatch();
  const radioFields = useSelector((state) => state.formData?.radioFields)
  let gridData = gridValues(null ,options);
  const selectedData = useSelector((state) => state.formData?.selectedData);
  const recursiveFormData = useSelector(
      (state) => state.recursive?.recursiveFormData
    );
  const paymentDetails = useSelector((state) => state.paymentReducer?.payment_details);
  const disablePartial = useSelector(
    (state) => state?.paymentReducer?.payment_details?.disable_partial
  );
  const userInfo = useSelector((state) => state.userInfo);
  const onChangeData =(e) =>{
    onChange(e)
    radioFields[`${name}`]?.map((item) => {
      dispatch(clearSelectedDataKey({key: item}))
    })
  }
  const search = window.location.search;
  const query = new URLSearchParams(search);

  const trigger = React.useMemo(() => {
    return query.get("trigger");
  }, [search, query]);

 useEffect(() => {
  const recursiveValue = recursiveFormData?.[name];
  const selectedValue = selectedData?.[name];

  if (!recursiveValue || !selectedValue) {
    const defaultOption = options?.find((opt) => eval(opt.auto_checked) === true);

    if (defaultOption) {
      dispatch(setRecursiveFormData({ key: name, value: defaultOption.label }));
      dispatch(setSelectedData({ key: name, value: defaultOption.label }));
    }
  }
}, [recursiveFormData, selectedData, name, options, dispatch]);
  return (
    <>
        <Label label={label} tooltip={tooltip} validators={validators}/>
    {
            options?.map((option) => {
              const { id, label, for: htmlFor, is_disabled, auto_checked } = option;
              let radioId = name + id;
              const show= option.show ? eval(option.show) : true;
              if(!show) return null;

              return (
<div key={radioId} className={`${size}`}>
                  <div className={eval(is_disabled) ? "disable_ms form-radio" : "form-radio"} >
                    <input
                      id={radioId}
                      type="radio"
                      name={name}
                      className="radio_input mt-0"
                      onChange={(e) => onChangeData(e)}
                      value={label}
                      checked={ (value?.label === label) ? true : false}
                      disabled={eval(is_disabled) ? true : isEditable ? false : true}
                    />
                    <label className={`radio_label p-2 d-flex align-items-center justify-content-start options ${errorClass} ${!isEditable && "radioDisabled"}`} htmlFor={radioId}>
                      <div className="dot"></div>
                      <span>{label}</span>
                    </label>
                  </div>
                </div>
              );
            })
          }
      {error?.length !== 0 && <ErrorMessage error={error} />}
    </>
  );
};

export default RadioInput;